// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1ndkj","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2BFh4"};